import { render } from "./SetRegularKey.vue?vue&type=template&id=2b74b684&scoped=true"
import script from "./SetRegularKey.vue?vue&type=script&lang=js"
export * from "./SetRegularKey.vue?vue&type=script&lang=js"

import "./SetRegularKey.vue?vue&type=style&index=0&id=2b74b684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b74b684"]])

export default __exports__